import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["expandableField"]

  connect() {
    const field = this.expandableFieldTarget
    field.style.overflow = "hidden"
    field.style.resize = "none"
    field.style.boxSizing = "border-box"
    requestAnimationFrame(() => this.adjustFieldHeight())
    setTimeout(() => this.adjustFieldHeight(), 500)
  }

  adjustFieldHeight() {
    const field = this.expandableFieldTarget
    // Reset height to measure true content height
    field.style.height = "auto"
    field.style.height = field.scrollHeight + "px"
  }
}
